import { useCallback } from 'react';
import { isPlatformBrowser } from '@utils/platform';

export type SendFunction = (data: { [key: string]: string | number | boolean }) => void;

/**
 * Send data to Google Tag Manager.
 * @return {(data: {[p: string]: string | number | boolean}) => void}
 */
export default function useGTM(): SendFunction {
  return useCallback((data) => {
    if (!isPlatformBrowser()) {
      return;
    }

    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    window.dataLayer.push(data);
  }, []);
}
